export default "__VITE_ASSET__BRJ3Sk_W__"